import Typography from '@mui/material/Typography'

interface OverlineChipProps {
  label: string
  variant?: 'subtle' | 'filled'
}

export default function OverlineChip({ label, variant = 'subtle' }: OverlineChipProps) {
  const filled = variant === 'filled'
  return (
    <Typography
      variant="overline"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1.75,
        py: 0.55,
        mb: 1.5,
        borderRadius: 999,
        letterSpacing: '0.18em',
        fontWeight: 700,
        fontSize: '0.7rem',
        ...(filled
          ? {
              color: '#0B2027',
              background: 'linear-gradient(135deg, #B87333 0%, #D4924D 100%)',
              boxShadow: '0 3px 12px rgba(184, 115, 51, 0.5)',
            }
          : {
              color: '#ffffff',
              background: 'linear-gradient(135deg, #B87333 0%, #D4924D 100%)',
              boxShadow: '0 3px 12px rgba(184, 115, 51, 0.4)',
            }),
      }}
    >
      {label}
    </Typography>
  )
}
